export const leadTypeOptions = [
  {
    value: "CL",
    title: "CL",
    children: [
      { value: "U", title: "U" },
      { value: "NC", title: "NC" },
      { value: "P", title: "P" },
    ],
  },
  {
    value: "DL",
    title: "DL",
    children: [
      { value: "LD", title: "LD" },
      { value: "GD", title: "GD" },
      { value: "BD", title: "BD" },
      { value: "PD", title: "PD" },
    ],
  },
];

export const cycleOptions = [
  { label: "Fresh", value: "fresh" },
  { label: "Recycle", value: "recycle" },
  { label: "Old", value: "old" },
  { label: "Sleep", value: "sleep" },
];

export const logStatusOptions = [
  { value: "pending", label: "미진행", color: "#D9D9D9" },
  { value: "appo", label: "아포", color: "#C7894B" },
  { value: "unappo", label: "아포취소", color: "#FED241" },
  { value: "demo", label: "데모", color: "#00B140" },
  { value: "contract", label: "계약완료", color: "#F04950" },
];

export const keepOptions = [
  { label: "해당없음", value: "false" },
  { label: "Keep", value: "true" },
];

export const duplicateOptions = [
  { label: "해당없음", value: "false" },
  { label: "중복", value: "true" },
];

export const refundOptions = [
  { label: "해당없음", value: "" },
  { label: "신청완료", value: "refunded" },
  { label: "리펀드완료", value: "requested" },
];

export const deleteOptions = [
  { label: "해당없음", value: "" },
  { label: "신청완료", value: "deleted" },
  { label: "삭제완료", value: "requested" },
];

export const refundReasonList = [
  { label: "IP 미신청자", value: 1 },
  { label: "전화번호 상이", value: 2 },
  { label: "외국인", value: 3 },
  { label: "동일가족 복수청구", value: 4 },
  { label: "부모 외 사람 IP청구", value: 5 },
  { label: "기 구매자", value: 6 },
  { label: "어프로치 거부자", value: 7 },
];

export const refundStatusList = [
  {
    label: "리펀드 요청",
    value: "requested",
  },
  {
    label: "리펀드 처리완료",
    value: "completed",
  },
  {
    label: "리펀드 요청 철회",
    value: "canceled",
  },
];

export const deleteStatusList = [
  {
    label: "삭제 요청",
    value: "requested",
  },
  {
    label: "삭제 처리완료",
    value: "completed",
  },
  {
    label: "삭제 요청 철회",
    value: "canceled",
  },
];

export const excelErrorList = [
  {
    label: "name-length",
    value: "잘못된 이름 형식",
  },
  {
    label: "name-empty",
    value: "KNAME/CNAME 누락",
  },
  {
    label: "zip",
    value: "ZIP 누락",
  },
  {
    label: "phone",
    value: "MBPHONE 누락",
  },
  {
    label: "birthday",
    value: "CBIRTH1 누락",
  },
  {
    label: "relation",
    value: '"부", "모", "기타" 만 허용됨',
  },
  {
    label: "media",
    value: "MEDIA 누락",
  },
  {
    label: "address1",
    value: "Address1 누락",
  },
  {
    label: "SGG_CD",
    value: "시/군/구 코드 누락",
  },
  {
    label: "ROAD_CD",
    value: "도로명 코드 누락",
  },
  {
    label: "EMD_CD",
    value: "법정동/법정리 코드 누락",
  },
  {
    label: "BULD_NO",
    value: "건물관리번호 누락",
  },
  {
    label: "LIDNO",
    value: "LIDNO 누락",
  },
  {
    label: "child-info",
    value: "Child info 누락",
  },
];

export const AnalyzedErrorList = [
  {
    label: "companyNumber",
    value: "에게 직접 배정됩니다.",
  },
  {
    label: "media",
    value: "존재하지 않는 미디어명 입니다.",
  },
  {
    label: "row-duplicate",
    value: "엑셀 파일에서 N번째 행과 중복됩니다.",
  },
  {
    label: "member-duplicate",
    value: "데이터베이스 기록(리드번호: XXXX)과 중복됩니다.",
  },
  {
    label: "no-kid",
    value: "임신중이 아니거나 6세 이하의 자녀가 없습니다.",
  },
  {
    label: "test",
    value: "테스트 데이터",
  },
];

export const RefundFailReasonList = [
  {
    label: "BEYOND_TWO_MONTHS_R",
    value: "리펀드 불가 - FCL 배분일 기준으로 2개월 이내가 아님",
  },
  {
    label: "INVALID_LEAD_TYPE_FOR_REFUND_R",
    value: "리펀드 불가 - 리드타입이 NC인 리드",
  },
  {
    label: "INVALID_LEAD_TYPE_FOR_DELETION_D",
    value: "삭제신청 불가 - 회사부스 리드",
  },
  {
    label: "DOOBANG_LEAD_R",
    value: "리펀드 불가 - 두방리드",
  },
  {
    label: "EXCEEDS_LIMIT_R",
    value: "리펀드 불가 - 리펀드 가능수량 초과",
  },
  {
    label: "ALREADY_REQUESTED_R",
    value: "리펀드 불가 - 이미 리펀드 또는 삭제 요청된 상태임",
  },
  {
    label: "ALREADY_REQUESTED_D",
    value: "삭제신청 불가 - 이미 리펀드 또는 삭제 요청된 상태임",
  },
  {
    label: "CONTRACTED_LEAD_R",
    value: "리펀드 불가 - 계약리드",
  },
  {
    label: "CONTRACTED_LEAD_D",
    value: "삭제신청 불가 - 이미 계약된 리드",
  },
  {
    label: "NOT_FOUND_R",
    value: "리펀드 불가 - 리드를 찾을 수 없음",
  },
  {
    label: "NOT_FOUND_D",
    value: "삭제신청 불가 - 리드를 찾을 수 없음",
  },
  {
    label: "INVALID_FOR_REFUND_AND_DELETION_R",
    value: "리펀드 불가 - FCL 리드만 가능",
  },
  {
    label: "INVALID_FOR_REFUND_AND_DELETION_D",
    value: "삭제신청 불가 - 회사 부스리드",
  },
];

export const HasDiversions = [
  "NOT_FOUND",
  "BEYOND_TWO_MONTHS",
  "INVALID_LEAD_TYPE_FOR_REFUND",
  "INVALID_LEAD_TYPE_FOR_DELETION",
  "INVALID_FOR_REFUND_AND_DELETION",
  "DOOBANG_LEAD",
  "EXCEEDS_LIMIT",
  "ALREADY_REQUESTED",
  "CONTRACTED_LEAD",
];

export const duplicateErrorMessageList = [
  {
    label: "CANNOT_EDIT_DUPLICATE_LEAD",
    value:
      "이미 동일한 전화번호를 가지고 있는 중복리드가 존재하기 때문에 전화번호 수정 불가",
  },
  {
    label: "EDIT_WOULD_CAUSE_DUPLICATE_LEAD",
    value:
      "이미 이름, 주소, 전화번호, 아이이름 및 생년월일 와 같은  중복리드가 존재하기 때문에 수정불가",
  },
];

export const DLCreationErrorList = [
  {
    label: "INVALID_LEAD_TYPE",
    value:
      "임산부 관련 입력 정보에 오류가 있어서 등록이 실패 되었습니다. 이를 확인하시고 다시 시도하여 주세요. 그래도 등록이 실패할 경우, 어드바이저 (관리자)에게 문의해 주세요.",
  },
  {
    label: "INVALID_TYPE_OR_ID",
    value:
      "그룹로컬마케팅 이벤트 관련 정보에 오류가 있어서 등록이 실패 되었습니다. 어드바이저 (관리자)에게 문의하여 주세요.",
  },
  {
    label: "INVALID_ADVISOR",
    value:
      "시스템에 등록되어 있는 어드바이저 정보에 에러가 발생하여 등록이 실패 되었습니다. 어드바이저 (관리자)에게 문의하여 주세요.",
  },
  {
    label: "STOP_CREATION_CONTRACT",
    value:
      "이미 계약이 완료된 고객은 등록할 수 없습니다. 어드바이저 (관리자)에게 문의하여 주세요.",
  },
  {
    label: "STOP_CREATION_SELF_ASSIGNED",
    value: "이미 등록된 고객입니다. 어드바이저 (관리자)에게 문의하여 주세요.",
  },
  {
    label: "INVALID_ADVISOR",
    value:
      "시스템에 등록되어 있는 어드바이저 정보에 에러가 발생하여 등록이 실패 되었습니다. 어드바이저 (관리자)에게 문의하여 주세요.",
  },
];
